import React from 'react';

import { ModalButtonType } from '@philips-emr/tws-constants';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import './dialog-service.scss';

class DialogServiceProvider {

  static confirm(dialogDescription: string): Promise<void> {
    return new Promise((resolve, reject) => ModalService.openDialog({
      title: 'provider.warning',
      closeable: false,
      dialogDescription,
      dockButtons: [
        {
          title: 'provider.close',
          type: ModalButtonType.CANCEL,
          action: reject,
        },
        {
          title: 'provider.ok',
          type: ModalButtonType.SUCCESS,
          action: resolve,
        },
      ],
    }));
  }

  static alert(dialogDescription: string): Promise<void> {
    return new Promise((resolve) => ModalService.openDialog({
      title:'provider.warning',
      closeable: false,
      children: (<div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: dialogDescription }} />),
      dockButtons: [
        {
          title: 'provider.ok',
          type: ModalButtonType.SUCCESS,
          action: resolve,
        },
      ],
    }));
  }
}

export {
  DialogServiceProvider,
};
